import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import {
  useWizardService,
  getIsFirstStep,
  getIsLastStep,
  getCurrentStepId,
} from '@bingads-webui-react/wizard';
import { CancelButton } from '@bingads-webui-react/wizard-ui-library';
import { BackButton, NextButton, SaveAndExitButton } from './footer';
import { STEP_PATHS } from '../step-constants';

export const AdGroupCreationFooter = ({
  nextButtonText,
  backButtonText,
  cancelButtonText,
}) => {
  const { state } = useWizardService();
  const isFirstStep = getIsFirstStep(state);
  const isLastStep = getIsLastStep(state);

  const currentStep = getCurrentStepId(state);

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }}>
      {isFirstStep && <NextButton buttonText={nextButtonText} />}
      {isFirstStep && <SaveAndExitButton />}
      {isFirstStep && <CancelButton buttonText={cancelButtonText} />}
      {!isFirstStep && <BackButton buttonText={backButtonText} />}
      {!isFirstStep && !isLastStep && <SaveAndExitButton buttonText={nextButtonText} />}
      {(isLastStep || currentStep === STEP_PATHS.MULTI_AD_MANAGER) && <SaveAndExitButton />}
    </Stack>
  );
};
AdGroupCreationFooter.propTypes = {
  nextButtonText: PropTypes.string,
  backButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};

AdGroupCreationFooter.defaultProps = {
  nextButtonText: undefined,
  backButtonText: undefined,
  cancelButtonText: undefined,
};
